/**
 * t504u: an announcement with nothing in "Who sees it" goes to the whole company, so the composer asks first. Shared by
 * the web composer (desktop and phone web) and the iPhone app. The API is unchanged: an empty audience still means everyone.
 */
type Aud = { location_ids?: readonly string[] | null; team_ids?: readonly string[] | null; user_ids?: readonly string[] | null; position_ids?: readonly string[] | null };

/** No buildings, teams, positions (t521u) or people picked: everyone in the workspace sees it. */
export const isEveryoneAudience = (a: Aud) => !a.location_ids?.length && !a.team_ids?.length && !a.user_ids?.length && !a.position_ids?.length;

/**
 * Ask before posting to everyone: a new (or scheduled) announcement with no audience, or an edit that cleared the audience.
 * An edit of a post that already went to everyone doesn't ask again.
 */
export const needsEveryoneConfirm = (next: Aud, before?: Aud | null) => isEveryoneAudience(next) && (!before || !isEveryoneAudience(before));

export const EVERYONE_CONFIRM = { title: 'Post to everyone?', confirmLabel: 'Post to everyone', cancelLabel: 'Choose who sees it' } as const;

/** 'No audience is selected, so this will be shown to everyone in Trade Outlet (42 people).' */
export function everyoneConfirmBody(workspace: string | null | undefined, people: number | null | undefined): string {
  const n = typeof people === 'number' ? ` (${people} ${people === 1 ? 'person' : 'people'})` : '';
  return `No audience is selected, so this will be shown to everyone in ${workspace?.trim() || 'the company'}${n}.`;
}
